import HttpClient from "./HttpClient";

import Authentication from "./Authentication";

export default class ApiClient {
  static refreshingPromise = null;

  static prefix = "admin";

  static authExpired = null;

  static addAuthExpiredListener = (callback) => {
    ApiClient.authExpired = () => {
      callback();
    };
    return ApiClient.authExpired;
  };

  static removeAuthExpiredListener = (callback) => {
    if (ApiClient.authExpired === callback) {
      ApiClient.authExpired = null;
    }
  };

  static request = async (
    method,
    route,
    body = null,
    multipart = false,
    allowTokenRefresh = true
  ) => {
    let error = null;

    if (ApiClient.refreshingPromise) {
      await ApiClient.refreshingPromise.catch((e) => {
        error = e;
      });
    }

    if (error) {
      return Promise.reject(error);
    }

    return HttpClient.request(
      method,
      `${ApiClient.prefix}/${route}`,
      Authentication.token,
      body,
      multipart
    ).catch(async (e) => {
      if (e.status === 401) {
        if (allowTokenRefresh) {
          let error = null;
          let refreshPromise = ApiClient.refreshToken();
          await refreshPromise.catch((e2) => {
            error = e2;
          });

          return error
            ? Promise.reject(e)
            : ApiClient.request(method, route, body, multipart, false);
        } else {
          ApiClient.authExpired();
        }
      } else {
        return Promise.reject(e);
      }
    });
  };

  static get = async (route) => ApiClient.request("GET", route);
  static post = async (route, body = null, multipart = false) =>
    ApiClient.request("POST", route, body, multipart);
  static put = async (route, body = null, multipart = false) =>
    ApiClient.request("POST", route + "?_method=PUT", body, multipart);
  static patch = async (route, body = null, multipart = false) =>
    ApiClient.request("POST", route + "?_method=PATCH", body, multipart);
  static delete = async (route) => ApiClient.request("DELETE", route);
}
